export class HrCommonConstants {
    public static readonly TODAY = new Date();
    public static readonly MAX_DATE = new Date('9999-12-31');

    private constructor() {}
}
